export enum Status {
  Inactive = 0,
  Active = 10,
}

export enum ResponsesTypes {
  list = 'list',
  text = 'text',
  userAutomatic = 'user_automatic',
  dateTimeAutomatic = 'datetime_automatic',
  number = 'number',
  checkbox = 'checkbox',
  datetime = 'datetime',
  photo = 'photo',
  annotation = 'annotation',
  signature = 'signature',
  dropdown = 'dropdown',
  instruction = 'instruction',
  qrCode = 'qrCode',
  entityItemAutomatic = 'entity_item_automatic',
  geoLocation = 'geolocation',
  entityItem = 'entity_item',
  file = 'file',
}

export enum SessionStorageKeys {
  AiTemplate = 'aiTemplate',
  ChecklistQuitRoute = 'checklistChooseMethodQuitRoute',
}

export enum LanguageTranslationStatus {
  pending = 'pending',
  inProgress = 'in_progress',
  completed = 'completed',
  failed = 'failed',
}
